export default "__VITE_ASSET__BfN6akRp__"